<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SSMMv6/Images/cover.jpg?1740318077073" alt="This image is the cover for the book His Majesty's Marriage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Majesty's Marriage
      </h1>
      <p class="bookDescription body article font2">
        <i>The Prince's Choice</i> by Rebecca Winters<br/><br/>Raoul D'Arillac has, as the heir to the throne, been betrothed to a stranger since he was born. But as his arranged wedding approaches, he realizes he's fallen for another woman. Yet schoolteacher Lee Gresham doesn't have a drop of royal blood....<br/><br/><i>The King's Bride</i> by Lucy Gordon<br/><br/>A life of duty and protocol had made King Daniel of Voltavia seem aloof. But after one kiss, Lizzie Booth could sense that underneath his cool exterior lay a passionate man. A man who was falling in love with Lizzie despite his best intentions....
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca Winters, Lucy Gordon
      </h2>
      
      <p class="authorDescription body article">Rebecca Winters lives in Salt Lake City, Utah. With canyons and high alpine meadows full of wildflowers, she never runs out of places to explore. They, plus her favourite vacation spots in Europe, often end up as backgrounds for her romance novels because writing is her passion, along with her family and church. Rebecca loves to hear from readers. If you wish to e-mail her, please visit her website at: www.cleanromances.net.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6942bdb2